// extracted by mini-css-extract-plugin
export var subtitle = "_b0-2";
export var title = "_b0-0";
export var titleNoWrap = "_b0-1";